import "core-js/modules/es.object.assign";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/web.dom-collections.iterator";
/* eslint-disable */

import { focusable } from '~/helpers/a11y';

const MicroModal = (() => {
  class Modal {
    constructor(_ref) {
      let {
        targetModal,
        triggers = [],
        onShow = () => {},
        onClose = () => {},
        openTrigger = 'data-micromodal-trigger',
        closeTrigger = 'data-micromodal-close',
        disableFocus = false,
        awaitCloseAnimation = false,
        debugMode = false
      } = _ref; // Save a reference of the modal

      this.modal = document.getElementById(targetModal); // Save a reference to the passed config

      this.config = {
        debugMode,
        openTrigger,
        closeTrigger,
        onShow,
        onClose,
        awaitCloseAnimation,
        disableFocus
      }; // Register click events only if prebinding eventListeners

      if (triggers.length > 0) {
        this.registerTriggers(...triggers);
      }

      ; // prebind functions for event listeners

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }
    /**
     * Loops through all openTriggers and binds click event
     * @param  {array} triggers [Array of node elements]
     * @return {void}
     */


    registerTriggers() {
      for (var _len = arguments.length, triggers = new Array(_len), _key = 0; _key < _len; _key++) {
        triggers[_key] = arguments[_key];
      }

      triggers.forEach(trigger => {
        trigger.addEventListener('click', event => this.showModal(event));
      });
    }

    showModal(event) {
      this.modal.setAttribute('aria-hidden', 'false');
      this.modal.classList.add('is-active');
      this.addEventListeners();
      this.config.onShow(this.modal, event);
      Frame.EventBus.emit("Modal:Show:".concat(this.modal.id), this.modal);
      setTimeout(() => {
        this.setFocusToFirstNode();
      }, 50);
    }

    closeModal(event) {
      const modal = this.modal;
      this.modal.setAttribute('aria-hidden', 'true');
      this.removeEventListeners();
      this.config.onClose(this.modal, event);
      Frame.EventBus.emit("Modal:Close:".concat(this.modal.id), this.modal); // Doesn't currently work with Micromodal.

      if (this.config.awaitCloseAnimation) {
        this.modal.addEventListener('animationend', function handler() {
          modal.classList.remove('is-active');
          modal.removeEventListener('animationend', handler, false);
          window.setTimeout(() => {
            window._previousFocus.focus();
          }, 700); // Animation close timeout
        }, false);
      } else {
        modal.classList.remove('is-active');
        window.setTimeout(() => {
          window._previousFocus.focus();
        }, 700); // Animation close timeout
      }
    }

    addEventListeners() {
      this.modal.addEventListener('touchstart', this.onClick);
      this.modal.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    removeEventListeners() {
      this.modal.removeEventListener('touchstart', this.onClick);
      this.modal.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onClick(event) {
      if (event.target.hasAttribute(this.config.closeTrigger)) {
        this.closeModal(event);
        event.preventDefault();
      }
    }

    onKeydown(event) {
      if (event.keyCode === 27) {
        this.closeModal(event);
      }

      ;

      if (event.keyCode === 9) {
        this.maintainFocus(event);
      }

      ;
    }

    getModalBody() {
      const modalBody = this.modal.querySelector('[js-modal="body"]');

      if (!modalBody) {
        return this.modal;
      }

      return modalBody.querySelectorAll('[js-modal="card"]:not(.is-hidden)')[0];
    }

    getFocusableNodes() {
      return focusable(this.getModalBody());
    }

    setFocusToFirstNode() {
      if (this.config.disableFocus) {
        return;
      }

      ;
      const focusableNodes = this.getFocusableNodes();

      if (focusableNodes.length) {
        focusableNodes[0].focus();
      }

      ;
    }

    maintainFocus(event) {
      const focusableNodes = this.getFocusableNodes(); // if disableFocus is true

      if (!this.modal.contains(document.activeElement)) {
        focusableNodes[0].focus();
      } else {
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);

        if (event.shiftKey && focusedItemIndex === 0) {
          focusableNodes[focusableNodes.length - 1].focus();
          event.preventDefault();
        }

        if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
          focusableNodes[0].focus();
          event.preventDefault();
        }
      }
    }

  }
  /**
   * Modal prototype ends.
   * Here on code is reposible for detecting and
   * autobinding event handlers on modal triggers
   */
  // Keep a reference to the opened modal


  let activeModal = null;
  /**
   * Generates an associative array of modals and it's
   * respective triggers
   * @param  {array} triggers     An array of all triggers
   * @param  {string} triggerAttr The data-attribute which triggers the module
   * @return {array}
   */

  const generateTriggerMap = (triggers, triggerAttr) => {
    const triggerMap = [];
    triggers.forEach(trigger => {
      const targetModal = trigger.attributes[triggerAttr].value;

      if (triggerMap[targetModal] === undefined) {
        triggerMap[targetModal] = [];
      }

      ;
      triggerMap[targetModal].push(trigger);
    });
    return triggerMap;
  };
  /**
   * Validates whether a modal of the given id exists
   * in the DOM
   * @param  {number} id  The id of the modal
   * @return {boolean}
   */


  const validateModalPresence = id => {
    if (!document.getElementById(id)) {
      console.warn("MicroModal v".concat(version, ": \u2757Seems like you have missed %c'").concat(id, "'"), 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', 'ID somewhere in your code. Refer example below to resolve it.');
      console.warn('%cExample:', 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', "<div class=\"modal\" id=\"".concat(id, "\"></div>"));
      return false;
    }
  };
  /**
   * Validates if there are modal triggers present
   * in the DOM
   * @param  {array} triggers An array of data-triggers
   * @return {boolean}
   */


  const validateTriggerPresence = triggers => {
    if (triggers.length <= 0) {
      console.warn("MicroModal v".concat(version, ": \u2757Please specify at least one %c'micromodal-trigger'"), 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', 'data attribute.');
      console.warn('%cExample:', 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', '<a href="#" data-micromodal-trigger="my-modal"></a>');
      return false;
    }
  };
  /**
   * Checks if triggers and their corresponding modals
   * are present in the DOM
   * @param  {array} triggers   Array of DOM nodes which have data-triggers
   * @param  {array} triggerMap Associative array of modals and thier triggers
   * @return {boolean}
   */


  const validateArgs = (triggers, triggerMap) => {
    validateTriggerPresence(triggers);

    if (!triggerMap) {
      return true;
    }

    ;

    for (let id in triggerMap) {
      validateModalPresence(id);
    }

    ;
    return true;
  };
  /**
   * Binds click handlers to all modal triggers
   * @param  {object} config [description]
   * @return void
   */


  const init = config => {
    // Create an config object with default openTrigger
    const options = Object.assign({}, {
      openTrigger: 'data-micromodal-trigger'
    }, config); // Collects all the nodes with the trigger

    const triggers = [...document.querySelectorAll("[".concat(options.openTrigger, "]"))]; // Makes a mappings of modals with their trigger nodes

    const triggerMap = generateTriggerMap(triggers, options.openTrigger); // Checks if modals and triggers exist in dom

    if (options.debugMode === true && validateArgs(triggers, triggerMap) === false) {
      return;
    }

    ; // For every target modal creates a new instance

    for (let key in triggerMap) {
      const value = triggerMap[key];
      options.targetModal = key;
      new Modal(options); // eslint-disable-line no-new
    }
  };
  /**
   * Shows a particular modal
   * @param  {string} targetModal [The id of the modal to display]
   * @param  {object} config [The configuration object to pass]
   * @return {void}
   */


  const show = (targetModal, config) => {
    const options = config || {};
    options.targetModal = targetModal; // Checks if modals and triggers exist in dom

    if (options.debugMode === true && validateModalPresence(targetModal) === false) {
      return;
    }

    ; // stores reference to active modal

    activeModal = new Modal(options); // eslint-disable-line no-new

    activeModal.showModal();
  };
  /**
   * Closes the active modal
   * @param  {string} targetModal [The id of the modal to display]
   * @return {void}
   */


  const close = targetModal => {
    const options = {};

    if (activeModal === null) {
      options.targetModal = targetModal; // stores reference to active modal

      activeModal = new Modal(options);
    }

    activeModal.closeModal();
  };

  return {
    init,
    show,
    close
  };
})();

export default MicroModal;